import React, { useState } from 'react'
import { useAuth } from '../../../contexts/auth'
import { VIEWS } from '../../auth/modals'
import MessageModal from '../../../components/message-modal'
import { Button } from '../../../components/button'

export default function CreateAccountSection() {
  const [{ isAuthenticated }, { setAuthModal }] = useAuth()
  const [alreadyRegisteredModal, setAlreadyRegisteredModal] = useState(false)

  const handleClick = () =>
    isAuthenticated
      ? setAlreadyRegisteredModal(true)
      : setAuthModal({ open: true, view: VIEWS.Register })

  return (
    <div className='root flex justifyCenter' style={{ paddingTop: '7rem', backgroundColor: '#212529' }}>
      <Button size='lg' style={{ borderRadius: '8px' }} onClick={handleClick}>
        Create an account
      </Button>

      {alreadyRegisteredModal && (
        <MessageModal
          title='Registration'
          text='You are already registered.'
          onClose={() => setAlreadyRegisteredModal(false)}
        />
      )}
    </div>
  )
}
